"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const NewProjectModal_1 = __importDefault(require("./NewProjectModal"));
exports.default = NewProjectModal_1.default;
